import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewMom from './viewMom';
import { getCorpClientList,getMomList } from 'services/redux/brandActivtion/corporateClient/action';
import {
    getMeetingById,
    cancelMeeting,
    completeMeeting,
} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    meetingById: state.baMeetingReducer.meetingById,
    cancel: state.baMeetingReducer.cancel,
    complete: state.baMeetingReducer.complete,
    corpClientList: state.CorpClientReducer.corpClientList,
    momListing: state.CorpClientReducer.getMomListing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMeetingById,
            cancelMeeting,
            completeMeeting,
            getCorpClientList,
            getMomList,
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(ViewMom);